import React, { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { MultiTab } from 'src/components';
import usePreviousLocation from 'src/hooks/usePreviousLocation';
import { useSelector, useDispatch } from 'react-redux';
import { onTabClose } from 'src/store/jobRequisitionTabs';
import { AppDispatch, AppRootState } from 'src/store';

export default function JobRequisitionLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const prevLocation = usePreviousLocation();
  const { pathname } = location;
  const { pathname: prevPathName } = prevLocation || {};
  const params = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const tabs = useSelector((state: AppRootState) => state.jobRequisitionTabs);

  useEffect(() => {
    if (pathname === '/job-requisition') {
      navigate('/job-requisition/job-list');
    }
  }, []);

  useEffect(() => {
    // handle job requisition link navigation
    if (prevPathName && prevPathName !== pathname && pathname === '/job-requisition') {
      navigate(prevPathName);
    }
  }, [prevPathName]);

  const onClose = (jobOrderId: string | number | undefined) => {
    dispatch(onTabClose(jobOrderId));
    const { id } = params;
    if (id && (jobOrderId === Number(id))) {
      navigate('/job-requisition/job-list');
    }
  };

  return (
    <div className="px-[2%] pt-[1%] w-[100%] mr-[3%]">
      <MultiTab
        tabs={tabs}
        onTabClose={onClose}
        scrollButtons
      />
    </div>
  );
}
